export const enum ETipoReavaliacaoDemanda {
    ReducaoEscopo = 1,
    AbrirNovaRC = 2,
    Cancelar = 3,
}
